export default __webpack_public_path__ + "static/media/Four-Star Rating Badge - Full Color.cf920502.png";